module.exports = __webpack_public_path__ + "static/clients_04@2x-892acdb9290771ba368ec0356ff8095d.png";